module.exports = __webpack_public_path__ + "static/media/moves.1aab4ea1.png";